
import { Button, notification, Typography } from "antd";
import { useCoordinator } from "@/shared/lib/hooks";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { Can } from "@shared/lib/casl";
import { useCreateJournal } from "../../model/create-journal.mutation";
import { ObjectJournalsList } from "../object-journals-list";
import { ObjectJournalsSkeleton } from "../object-journals-skeleton";
import "./object-journals.scss";

const { Title } = Typography;

export const ObjectJournals = () => {
  const { objectId } = useCoordinator();

  const { mutate, isPending } = useCreateJournal({
    buildingObjectId: objectId,
  });



  const handleCreateJournal = () => {
    mutate(
      { buildingObjectId: objectId },
      {
        onSuccess: () => {
          notification.success({
            message: NOTIFICATION_MESSAGES.SUCCESS, // "Успешно"
            description: NOTIFICATION_MESSAGES.JOURNAL_CREATED_DESC, // "Создали журнал"
            placement: "topRight",
            showProgress: false,
          });
        },
        onError: () => {
          notification.error({
            message: NOTIFICATION_MESSAGES.ERROR, // "Ошибка"
            description: NOTIFICATION_MESSAGES.JOURNAL_CREATE_FAILED_DESC, // "Невозможно создать журнал"
            placement: "topRight",
            showProgress: false,
          });
        },
      },
    );
  };
  return (
    <>
      <div className="object-journals__header">
        <Title level={4}>Список журналов объекта</Title>
        <Can I="edit" a="object">
          <Button type="default" onClick={handleCreateJournal}>
            Создать ОЖР
          </Button>
        </Can>
      </div>
      {isPending ? (
        <>
          <ObjectJournalsSkeleton />
        </>
      ) : null}
      <ObjectJournalsList />
    </>
  );
};
